import React from "react";
import { t, Trans } from "@lingui/macro";
import _ from "lodash";
import aboutUsImage from "../images/interested-cards/about-us.png";
import blockchainImage from "../images/interested-cards/blockchain.png";
import investmentSolutionsImage from "../images/interested-cards/investment-solutions.png";
import mediaImage from "../images/interested-cards/media.png";
import historyImage from "../images/interested-cards/history.png";
import esgImage from "../images/interested-cards/esg.png";
import policiesImage from "../images/interested-cards/policies.png";
import pillarsImage from "../images/interested-cards/strategic-pillars.png";
import esgReportsImage from "../images/interested-cards/esg-reports.png";
import investorRelationsImage from "../images/interested-cards/investor-relations.png";
import contactImage from "../images/interested-cards/contact.png";
import aboutAllfundsImage from "../images/interested-cards/about-allfunds.png";
import shareInformationImage from "../images/interested-cards/share-information.png";
import shareholderMettingsImage from "../images/interested-cards/shareholder-mettings.png";
import investorsContactImage from "../images/interested-cards/investors-contact.png";
import careersImage from "../images/interested-cards/careers.png";
import distributorsImage from "../images/interested-cards/distributors.png";
import fundHousesImage from "../images/interested-cards/fund-houses.png";
import teamImage from "../images/interested-cards/team.png";
import faqsImage from "../images/interested-cards/faqs.png";
import onboardFundHouseImage from "../images/interested-cards/onboard-fund-house.png";
import financialInfoBankImage from "../images/interested-cards/financial-info-bank.png";
import financialInfoGroupImage from "../images/interested-cards/financial-info-group.png";
import financialCalendarImage from "../images/interested-cards/financial-calendar.png";
import ipoInformationImage from "../images/interested-cards/ipo-information.png";
import governanceBankImage from "../images/interested-cards/governance-bank.png";
import governanceGroupImage from "../images/interested-cards/governance-group.png";
import blog from "../cms/blog/blog";
import esgDocs from "../cms/esgDocs/esgDocs";
import financialInformationDocs from "../cms/financialInformationDocs/financialInformationDocs";
import governanceDocs from "../cms/governanceDocs/governanceDocs";
import ipoInformationDocs from "../cms/ipoInformationDocs/ipoInformationDocs";
import policiesStatementsDocs from "../cms/policiesStatementsDocs/policiesStatementsDocs";
import shareholderMeetingsDocs from "../cms/shareholderMeetingsDocs/shareholderMeetingsDocs";
import shareInformationDocs from "../cms/shareInformationDocs/shareInformationDocs";
import { metadata } from "./metadata";

export const headers = () => ({
  investors: {
    // label: <Trans>Investors</Trans>,
    label: "Investors",
    path: "/investors",
    metadata: metadata.investors,
    elements: {
      investors_about: {
        // label: <Trans>About Allfunds</Trans>,
        // description: (
        //   <Trans>Learn more about our strategy and key fundamentals</Trans>
        // ),
        label: "About Allfunds",
        description: "Learn more about our strategy and key fundamentals",
        path: "/investors/about",
        image: aboutAllfundsImage,
        metadata: metadata.investors_about,
        // elements: {
        //   strategy: {
        //     label: <Trans>Our Strategy</Trans>,
        //     description: <Trans>Allfunds 3.0</Trans>,
        //     path: "/investors/about",
        //     // state: { ref: "strategy" },
        //     image: aboutAllfundsImage,
        //   },
        //   investments: {
        //     label: <Trans>Investment Case</Trans>,
        //     description: (
        //       <Trans>Learn more about our investment case highlights</Trans>
        //     ),
        //     path: "/investors/about",
        //     state: { ref: "investment" },
        //   },
        // },
      },
      governance: {
        label: "Governance",
        description:
          "Read more about Allfunds Group plc, its Directors and Comittee members.",
        // label: <Trans>Governance</Trans>,
        // description: (
        //   <Trans>
        //     Read more about Allfunds Group plc, its Directors and Comittee
        //     members.
        //   </Trans>
        // ),
        elements: {
          allfunds_group: {
            label: "Allfunds Group plc",
            // label: <Trans>Allfunds Group plc</Trans>,
            path: "/investors/governance/group",
            image: governanceGroupImage,
            metadata: metadata.governance_group,
          },
          allfunds_bank: {
            label: "Allfunds Bank, S.A.U.",
            // label: <Trans>Allfunds Bank, S.A.U.</Trans>,
            path: "/investors/governance/bank",
            image: governanceBankImage,
            metadata: metadata.governance_bank,
          },
        },
      },
      share_information: {
        label: "Share Information",
        description:
          "All the information related to Allfunds’ share price, capital and shareholding",
        // label: <Trans>Share Information</Trans>,
        // description: (
        //   <Trans>
        //     All the information related to Allfunds’ share price, capital and
        //     shareholding
        //   </Trans>
        // ),
        path: "/investors/share",
        image: shareInformationImage,
        metadata: metadata.share,
        elements: {
          share_price: {
            label: "Allfunds share price",
            description: "Read more about Allfunds share price.",
            // label: <Trans>Allfunds share price</Trans>,
            // description: <Trans>Read more about Allfunds share price.</Trans>,
            path: "/investors/share#price",
            // state: { ref: "price" },
          },
          capital_shareholding: {
            label: "Capital and Shareholding",
            description: "Read more about capital and shareholding.",
            // label: <Trans>Capital and Shareholding</Trans>,
            // description: (
            //   <Trans>Read more about capital and shareholding.</Trans>
            // ),
            path: "/investors/share#capital",
            // state: { ref: "capital" },
          },
          analyst_coverage: {
            // label: <Trans>Analyst Coverage</Trans>,
            // description: (
            //   <Trans>
            //     Read more about the sell-side analysts actively cover for
            //     Allfunds.
            //   </Trans>
            // ),
            label: "Analysts",
            description:
              "Read more about the sell-side analysts actively cover for Allfunds.",
            path: "/investors/share#coverage",
            // state: { ref: "coverage" },
          },
          policy: {
            label: "Dividend and distribution policy",
            // label: <Trans>Dividend and distribution policy</Trans>,
            path: "/investors/share#dividend",
            // state: { ref: "dividend" },
          },
        },
      },
      financial_information_reports: {
        // label: <Trans>Financial Information and Reports</Trans>,
        // description: (
        //   <Trans>
        //     Here you will find our latest and archived Annual & Interim results
        //     announcements, webcasts and presentations.
        //   </Trans>
        // ),
        label: "Financial Information and Reports",
        description:
          "Here you will find our latest and archived Annual & Interim results announcements, webcasts and presentations.",
        elements: {
          financial_reports: {
            // label: <Trans>Allfunds Financial Reports</Trans>,
            label: "Allfunds Financial Reports",
            path: "/investors/financial/financial-reports",
            image: financialInfoGroupImage,
            metadata: metadata.financial_reports,
          },
          bank_reports: {
            // label: <Trans>Allfunds Bank Financial Reports</Trans>,
            // description: (
            //   <Trans>
            //     Find the latest financial and corporate governance reports
            //     issued by Allfunds.
            //   </Trans>
            // ),
            label: "Allfunds Bank Financial Reports",
            description:
              "Find the latest financial and corporate governance reports issued by Allfunds.",
            path: "/investors/financial/bank-reports",
            image: financialInfoBankImage,
          },
          financial_calendar: {
            // label: <Trans>Financial Calendar</Trans>,
            // description: (
            //   <Trans>
            //     Check our calendar of all quarterly trading statements, interim
            //     and preliminary results, and financial events.
            //   </Trans>
            // ),
            label: "Financial Calendar",
            description:
              "Check our calendar of all quarterly trading statements, interim and preliminary results, and financial events.",
            path: "/investors/financial/calendar",
            image: financialCalendarImage,
            metadata: metadata.calendar,
          },
          ipo: {
            // label: <Trans>IPO information</Trans>,
            // description: (
            //   <Trans>
            //     Here you will find our latest IPO information and documents.
            //   </Trans>
            // ),
            label: "IPO information",
            description:
              "Here you will find our latest IPO information and documents.",
            path: "/investors/financial/ipo",
            image: ipoInformationImage,
            metadata: metadata.ipo,
          },
        },
      },
      shareholder_meetings: {
        // label: <Trans>Shareholder Meetings</Trans>,
        // description: (
        //   <Trans>
        //     Find out about the Annual General Meeting and other general
        //     meetings.
        //   </Trans>
        // ),
        label: "Shareholder Meetings",
        description:
          "Find out about the Annual General Meeting and other general meetings.",
        path: "/investors/shareholder-meetings",
        image: shareholderMettingsImage,
        metadata: metadata.shareholder_meetings,
      },
      faqs: {
        // label: <Trans>FAQs</Trans>,
        // description: (
        //   <Trans>Read about the FAQs related to share information.</Trans>
        // ),
        label: "FAQs",
        description: "Read about the FAQs related to share information.",
        path: "/investors/faqs",
        image: faqsImage,
        metadata: metadata.faqs,
      },
      contact: {
        // label: <Trans>Contact</Trans>,
        // description: <Trans>Reach out to our Investor Relations team</Trans>,
        label: "Contact",
        description: "Reach out to our Investor Relations team.",
        path: "/investors/contact",
        image: investorsContactImage,
        metadata: metadata.investors_contact,
      },
    },
  },
  esg: {
    label: "Sustainability",
    elements: {
      approach_esg: {
        label: <Trans>Approach</Trans>,
        description: (
          <Trans>
            Since our beginning, we seek to strike the right balance between
            economic, social and environmental aspects to achieve business
            sustainability.
          </Trans>
        ),
        path: "/esg/approach",
        image: esgImage,
        metadata: metadata.esg_approach,
      },
      strategic_pillars: {
        label: <Trans>Pillars</Trans>,
        description: (
          <Trans>
            Our Corporate Social Responsibility commitments have developed
            through key initiatives of our Strategic Social Responsibility plan.
          </Trans>
        ),
        path: "/esg/strategic-pillars",
        image: pillarsImage,
        metadata: metadata.strategic_pillars,
      },
      reports: {
        label: <Trans>Reports</Trans>,
        description: (
          <Trans>Find the latest ESG Reports issued by Allfunds.</Trans>
        ),
        image: esgReportsImage,
        path: "/esg/reports",
        metadata: metadata.esg_reports,
      },
      policies_statements: {
        label: <Trans>Policies and Statements</Trans>,
        description: (
          <Trans>
            Allfunds works to continually improve the solutions it offers with
            vocation, quality, innovation, information safety and by creating
            shared value for all stakeholders.
          </Trans>
        ),
        image: policiesImage,
        path: "/esg/policies-statements",
        metadata: metadata.policies_statements,
      },
    },
  },
  careers: {
    label: <Trans>Careers</Trans>,
    path: "/careers",
    image: careersImage,
    metadata: metadata.careers,
  },
  media: {
    label: <Trans>Media</Trans>,
    path: "/blog",
    image: mediaImage,
    metadata: metadata.media,
  },
  contact: {
    label: <Trans>Contact</Trans>,
    alternativeTitle: <Trans>Contact Us</Trans>,
    description: <Trans>Reach out to out Investor Relations team</Trans>,
    path: "/contact",
    image: contactImage,
    metadata: metadata.contact,
  },
});

export const restHeaders = () => ({
  about: {
    label: <Trans>About Us</Trans>,
    elements: {
      overview: {
        label: <Trans>Overview</Trans>,
        path: "/about",
        alternativeTitle: <Trans>About Us</Trans>,
        description: (
          <Trans>
            Allfunds is one of the world’s leading B2B WealthTech companies.
          </Trans>
        ),
        image: aboutUsImage,
        metadata: metadata.about,
      },
      about_team: {
        label: <Trans>Our Team</Trans>,
        description: <Trans>Meet our team and leadership</Trans>,
        path: "/about/team",
        image: teamImage,
        metadata: metadata.about_team,
      },
      about_history: {
        label: <Trans>Our History & Global Presence</Trans>,
        path: "/about/history",
        description: <Trans>Learn more about our story so far</Trans>,
        image: historyImage,
        metadata: metadata.about_history,
      },
    },
  },
  distributors: {
    label: <Trans>Distributors</Trans>,
    alternativeTitle: <Trans>Our Value Proposition for Distributors</Trans>,
    path: "/distributors",
    image: distributorsImage,
    metadata: metadata.distributors,
  },
  fund_houses: {
    label: <Trans>Fund Houses</Trans>,
    alternativeTitle: <Trans>Our Value Proposition for Fund Houses</Trans>,
    path: "/fund-houses",
    image: fundHousesImage,
    metadata: metadata.fund_houses,
  },
});

export const additionalLinks = () => ({
  blockchain: {
    label: <Trans>Allfunds Blockchain</Trans>,
    path: "/distributors/blockchain",
    image: blockchainImage,
    metadata: metadata.distributors_blockchain,
  },
  investment_solutions: {
    label: <Trans>Investment Solutions</Trans>,
    path: "/distributors/investment",
    image: investmentSolutionsImage,
  },
  investment_solutions_fh: {
    label: <Trans>ManCo Services</Trans>,
    path: "/fund-houses/investment",
    image: teamImage,
  },
  investors_relations: {
    label: <Trans>Investor Relations</Trans>,
    description: (
      <Trans>
        Our Allfunds Investor site covers Allfunds’ financials, governance and
        share information
      </Trans>
    ),
    path: "/investors/about",
    image: investorRelationsImage,
  },
  onboard_fund_house: {
    label: <Trans>Onboard now as a Fund House</Trans>,
    path: "https://onboarding.allfunds.com/",
    image: onboardFundHouseImage,
  },
});

export const defaultInterestedItems = [
  _.get(restHeaders(), "about.elements.about_history", {}),
  _.get(additionalLinks(), "blockchain", {}),
  _.get(additionalLinks(), "investment_solutions", {}),
  _.get(headers(), "investors.elements.investors_about", {}),
  _.get(headers(), "contact", {}),
  _.get(headers(), "esg.elements.approach_esg", {}),
  _.get(additionalLinks(), "investors_relations", {}),
  _.get(headers(), "careers", {}),
];

const parsedData = (items, parent, keyPath) =>
  items.map(({ attributes }) => ({
    group: `${parent?.label.props ? parent?.label.props.id : parent?.label}${
      attributes.category
        ? ` - ${attributes.category.replaceAll("_", " ")}`
        : ""
    }`,
    label: attributes.title,
    path: keyPath ? `${parent.path}/${attributes[keyPath]}` : `${parent.path}`,
  }));

export const getOptionsMenu = (locale = "en") => {
  const careersValue = [
    t`All for Excellence`,
    t`All for Accountability`,
    t`All for Empowermentt`,
    t`All for Inspiration`,
  ].map((value) => ({
    group: "Careers - Our Values",
    label: value,
    path: "/careers",
  }));

  const parsedBlog = parsedData(
    Object.values(blog[locale]),
    headers().media,
    "slug",
  );
  const parsedEsgDocs = parsedData(
    esgDocs[locale],
    headers().esg.elements.reports,
  );
  const parsedFinancialInformationDocs = parsedData(
    financialInformationDocs[locale],
    headers().investors.elements.financial_information_reports.elements
      .financial_reports,
  );
  const parsedIpoInformationDocs = parsedData(
    ipoInformationDocs[locale],
    headers().investors.elements.financial_information_reports.elements.ipo,
  );
  const parsedPoliciesStatementsDocs = parsedData(
    policiesStatementsDocs[locale],
    headers().esg.elements.policies_statements,
  );
  const parsedShareholderMeetingsDocs = parsedData(
    shareholderMeetingsDocs[locale],
    headers().investors.elements.shareholder_meetings,
  );
  const parsedShareInformationDocs = parsedData(
    shareInformationDocs[locale],
    headers().investors.elements.share_information,
  );
  const parsedGovernanceDocsBank = parsedData(
    governanceDocs[locale].filter(
      ({ attributes }) => attributes.company === "Allfunds_Bank",
    ),
    headers().investors.elements.governance.elements.allfunds_bank,
  );
  const parsedGovernanceDocs = parsedData(
    governanceDocs[locale].filter(
      ({ attributes }) => attributes.company === "Allfunds",
    ),
    headers().investors.elements.governance.elements.allfunds_group,
  );
  const result = [
    careersValue,
    parsedBlog,
    parsedEsgDocs,
    parsedFinancialInformationDocs,
    parsedIpoInformationDocs,
    parsedPoliciesStatementsDocs,
    parsedShareholderMeetingsDocs,
    parsedShareInformationDocs,
    parsedGovernanceDocs,
    parsedGovernanceDocsBank,
  ].flat();
  return Object.values(_.groupBy(result, "group")).flat();
};

// export const getOptionsMenu = (
//   items = headers(),
//   result = [],
//   group = undefined
// ) => {
//   Object.entries(items).map(([key, values]) => {
//     const label = values.label?.props?.id
//     result.push({ id: key, label, group: group || label, path: values.path })
//     if (values.elements) getOptionsMenu(values.elements, result, group || label)
//   })
//   return result
// }
